let DTODAV03 = {
  insertEventAction: "/api/DTODAV03/insertEventAction",
  getTotalCnt: "/api/DTODAV03/getTotalCnt",
};

export default DTODAV03;
